import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { ISeoData } from '../types/seoData';

export const mapSeoData = (promosResponse: ISearchPromosV2ResponseSchema): ISeoData => {
  const seoData = promosResponse.seoData;

  return {
    metaDescription: seoData.metaDescription || '',
    title: seoData.title || '',
    h1: seoData.h1 || '',
    pageDescription: seoData.pageDescription || '',
    markedList: seoData.markedList || {
      items: [],
    },
    promoCategoryDetails: seoData.promoCategoryDetails || null,
  };
};
